<template>
  <div>
    <b-row>
      <b-col md="12">
        <component-header
          title="Add Resource"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push('/setup/Resources')"
        />
      </b-col>
      <b-col md="12" class="pb-0 pt-0">
        <b-card class="custome-card mb-2">
          <b-row>
            <b-col md="6">
              <b-form-group class="mb-0">
                <b-form-checkbox
                  type="checkbox"
                  size="lg"
                  id="isThis_Currency"
                  v-model="$store.state['currency'].isCurrency"
                  value="true"
                  @click="showResources"
                >
                  <h4 class="m-0 font-weight-light">Is this currency?</h4>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="this.$store.state['currency'].isCurrency" class="mt-2">
            <b-col md="6 pb-3">
              <eb-select
                type="select"
                :options="resourceData"
                label="resourceCode"
                id="ResourceCode"
                placeholder="Currency Code"
                class="mt-0"
                v-model="selectedCode"
                :selected="selectedCode"
                @input="onSelectCode(selectedCode)"
              ></eb-select>
            </b-col>
            <b-col md="6">
              <b-form-input
                inputType="text"
                placeholder="Resource Name"
                class="mt-0"
                readonly
                v-model="selectedName"
              />
            </b-col>
            <b-col md="6">
              <b-form-input
                inputType="text"
                placeholder="Resource Symbol"
                class="mt-0"
                readonly
                v-model="selectedSymbol"
              />
            </b-col>
            <b-col md="6">
              <b-form-input
                inputType="text"
                placeholder="Resource ID"
                class="mt-0"
                readonly
                v-model="selectedId"
              />
            </b-col>
          </b-row>

          <b-row v-if="!this.$store.state['currency'].isCurrency">
            <b-col md="6">
              <b-form-input
                inputType="text"
                placeholder="Resource Code"
                class="mt-2"
                v-model="selectedCode"
              />
            </b-col>
            <b-col md="6">
              <b-form-input
                inputType="text"
                placeholder="Resource Name"
                class="mt-2"
                v-model="selectedName"
              />
            </b-col>
            <b-col md="6">
              <b-form-input
                inputType="text"
                placeholder="Resource Symbol"
                class="mt-2"
                v-model="selectedSymbol"
              />
            </b-col>
            <b-col md="6">
              <b-form-input
                inputType="text"
                placeholder="Resource ID"
                class="mt-2"
                v-model="selectedId"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col
        md="12"
        class="pb-0 pt-0"
        v-if="this.$store.state['currency'].isCurrency"
      >
        <h3 class="mb-3">Add Currency Exchange Rate</h3>
        <b-card class="custome-card mb-3">
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <b-row>
              <b-col class="mt-3" md="3">
                <eb-select
                  placeholder="Select Currency"
                  label="text"
                  type="select"
                  v-model="selectCurrency"
                  @input="selectCurrencyData(selectCurrency)"
                  clearable
                  :selected="selectCurrency"
                  :options="resourceCurrency"
                >
                </eb-select>
              </b-col>
              <b-col class="mt-3" md="3">
                <b-form-input
                  inputType="number"
                  placeholder="Enter Exchange Rate"
                  class="mt-0"
                  v-model="exchangeRate"
                />
              </b-col>
              <b-col md="3">
                <ValidationProvider
                  rules="futureDisable"
                  v-slot="{ errors }"
                  name="start-date"
                >
                  <span class="ml-1">Start Date</span>
                  <b-input type="date" v-model="effetiveStartDate"> </b-input>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                <ValidationProvider
                  rules="futureDisable|afterDate:start-date"
                  v-slot="{ errors }"
                  name="end-date"
                >
                  <span class="ml-1">End Date</span>
                  <b-input type="date" v-model="effetiveEndDate"> </b-input>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col md="12" class="text-right"
                ><button
                  type="button"
                  class="btn btn-primary w-30"
                  classic="mr-1 btn-primary"
                  text="Save"
                  :disabled="invalid"
                  @click="addCurrencyData"
                >
                  Add
                </button></b-col
              >
            </b-row>
          </ValidationObserver>
        </b-card>
        <b-card class="custome-card">
          <div>
            <b-table
              class="tableRadius"
              :dark="false"
              :hover="true"
              :striped="false"
              :bordered="true"
              :small="false"
              :fixed="false"
              responsive
              :items="showExchangeRate"
              :fields="currencyAddPage"
              :current-page="currentPage"
              :per-page="perPage"
              thead-class="header"
              @filtered="onFilter"
              show-empty
              :busy="loading"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <template slot="updatedAt" slot-scope="data">
                <div>{{ data.item.updatedAt | formatedate }}</div>
              </template>
              <template slot="empty">
                <div v-if="loading" class="text-center">
                  <span><b>Loading...</b></span>
                </div>
                <div v-else class="text-center">No data available.</div>
              </template>
              <template slot-scope="data" slot="action">
                <div class="inline_btnTable">
                  <b-button
                    size="sm"
                    class="mr-2 button-circle delete"
                    @click="onClickDelete(data.index)"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
          <div class="float-right">
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="filterCount"
              aria-controls="my-table"
              prev-text="Prev"
              next-text="Next"
              hide-goto-end-buttons
            ></b-pagination>
          </div>
        </b-card>
      </b-col>

      <b-col md="12">
        <div class="text-center mb-5 mt-2 p-4">
          <button
            type="button"
            class="text-uppercase btn btn-lg btn-outline-primary mr-3 w-15"
            @click="backToResources"
          >
            Cancel
          </button>
          <button
            type="button"
            class="text-uppercase btn btn-lg btn-primary ml-3 w-15"
            classic="mr-1 btn-primary"
            text="Save"
            @click="addCurrencyEvent"
          >
            Save
          </button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import currency from "@/store/currency";
import ComponentHeader from "@/components/componentNewHeader";
import moment from "moment";
import { resourcesCurrency } from "@/utils/resourcesCurrency";
import {
  ValidationObserver,
  ValidationProvider,
  Validator,
} from "vee-validate";
export default {
  name: "addCurrency",
  components: {
    ValidationObserver,
    ValidationProvider,
    ebSelect,
    loader,
    ComponentHeader,
  },
  data() {
    return {
      selectedCode: "",
      selectedName: "",
      selectedId: "",
      selectedSymbol: "",
      filterCount: 0,
      loading: false,
      perPage: 10,
      currentPage: 1,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      sortBy: "updatedAt",
      sortDesc: true,
      showExchangeRate: [],
      currencyAddPage: [
        {
          key: "code.text",
          label: "Currency",
        },
        {
          key: "rate",
          label: "Exchange Rate",
        },
        {
          key: "startDate",
          label: "Effective Start Date",
          formatter: "formateStartdate",
        },
        {
          key: "endDate",
          label: "Effective End Date",
          formatter: "formateStartdate",
        },
        {
          key: "action",
          label: "Action",
          thStyle: { width: "8%" },
        },
      ],
      currency: "",
      currencyName: "",
      selectCurrency: "",
      exchangeRate: null,
      effetiveStartDate: "",
      effetiveEndDate: "",
      resourceID: "",
      isThisCurrency: "false",
    };
  },
  computed: {
    ...mapState({
      fetchCurrencyList: (state) => state.currency.fetchCurrencyList,
    }),
    resourceData() {
      return resourcesCurrency;
    },
    resourceCurrency() {
      let currencyVar = [];
      this.fetchCurrencyList.forEach((currencyDetails) => {
        if (currencyDetails.isCurrency === true) {
          currencyVar.push({
            text: currencyDetails.code,
            value: currencyDetails._id,
          });
        }
      });
      const unique = [
        ...new Map(currencyVar.map((item) => [item.text, item])).values(),
      ];
      return unique;
    },
  },
  methods: {
    onSelectCode(e) {
      this.selectedCode = e.resourceCode;
      this.selectedName = e.resourceName;
      this.selectedId = e.resourceId;
      this.selectedSymbol = e.resourceSymbol;
    },
    showResources() {
      this.$store.commit("currency/updateCurrency", false);
      //this.isThisCurrency = !this.isThisCurrency;
    },
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    async addCurrencyEvent() {
      if (!this.selectedCode) {
        this.$toasted.error("Please select Currency code");
        return;
      }
      let payload = {
        resourceID: this.selectedId,
        code: this.selectedCode,
        name: this.selectedName,
        symbol: this.selectedSymbol,
        isCurrency: this.$store.state["currency"].isCurrency,
        exchangeRates: [],
      };
      payload.exchangeRates = this.showExchangeRate.map((el) => {
        return {
          resource: {
            _id: el.code.value,
            code: el.code.text,
          },
          startDate: el.startDate,
          endDate: el.endDate,
          rate: el.rate,
        };
      });
      await this.$store
        .dispatch("currency/AddCurrency", payload)
        .then(async (res) => {
          this.currency = "";
          this.currencyName = "";
          this.selectCurrency = "";
          this.exchangeRate = null;
          this.effetiveStartDate = "";
          this.effetiveEndDate = "";
          this.$router.push("/setup/Resources");
        });
    },
    addCurrencyData() {
      if (
        !this.selectCurrency ||
        !this.exchangeRate ||
        !this.effetiveStartDate ||
        !this.effetiveEndDate
      ) {
        this.$toasted.error("Please fill all fields");
        return;
      }
      const dateValid =
        this.effetiveStartDate &&
        this.effetiveEndDate &&
        moment(this.effetiveStartDate).diff(this.effetiveEndDate, "day") < 0;
      if (!dateValid) {
        this.$toasted.error("Please select valid date range");
        return;
      }
      let currencyExchangeData = {
        code: this.selectCurrency,
        rate: this.exchangeRate,
        startDate: this.effetiveStartDate,
        endDate: this.effetiveEndDate,
      };
      this.showExchangeRate.push(currencyExchangeData);
      this.selectCurrency = "";
      this.exchangeRate = "";
      this.effetiveStartDate = "";
      this.effetiveEndDate = "";
      this.selectCurrencyData("");
    },
    onClickDelete(index) {
      this.showExchangeRate.splice(index, 1);
    },
    selectCurrencyData(e) {
      this.selectCurrency = e;
      const selectedCurrencyDetails = this.fetchCurrencyList.filter(
        (el) => el.code === e.value
      );
    },
    backToResources() {
      this.$router.push("/setup/Resources");
    },
  },
  async mounted() {
    await this.$store.dispatch("currency/fetchCurrencySetupList");

    Validator.extend(
      "afterDate",
      (value, [otherValue]) => {
        return moment(value).diff(this.effetiveStartDate, "hour") >= 0;
      },
      {
        hasTarget: true,
      }
    );
    Validator.extend(
      "futureDisable",
      (value, [otherValue]) => {
        return moment().diff(this.effetiveStartDate, "hour") >= 0;
      },
      {
        hasTarget: true,
      }
    );
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm A");
      }
    },
  },
};
</script>
<style scoped>
.heading-ul {
  padding: 0;
}
.heading-ul li {
  list-style: outside none;
  display: inline-block;
  margin-right: 10px;
}
input[type="date"]:after {
  content: attr(placeholder);
  position: absolute;
  right: 20%;
  top: 18%;
}
</style>
